module.exports = __webpack_public_path__ + "img/Osaka.b2e88678.jpg";